import { createApiClient, createLocalStorageTokenStorage } from 'grabbitbot-legacy-ui'
import { API_BASE_URL } from '../config'

// One ApiClient + one token storage instance for the whole app — shared by
// AuthProvider and every domain client added in later rounds. See
// grabbitbot-legacy-ui README "Wiring example".
export const tokenStorage = createLocalStorageTokenStorage('authToken')

// `onUnauthorized` clears the token as soon as ANY request comes back 401 —
// this is the fix for audit §3/§10 defect 6 ("no global 401 handling / no
// forced re-login"): the legacy app just left silent, per-widget failures on
// screen. Clearing the token here flips `AuthProvider`'s `user` to `null` on
// its next `refresh()`, and every protected route's `RequireAuth` (see
// src/routes/AppRoutes.tsx) then renders its `fallback` — a redirect to
// `/login` — instead of the legacy's "nothing happens" behaviour.
export const apiClient = createApiClient({
  baseUrl: API_BASE_URL,
  getToken: () => tokenStorage.get(),
  onUnauthorized: () => tokenStorage.clear(),
})
